import {
  ColorsWhite,
  ColorsNeutral200,
  Spacings10,
  Spacings4,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const wrapper = css({
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  padding: `${Spacings4} ${Spacings10}`,
  borderTop: `1px solid ${ColorsNeutral200}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: ColorsWhite,
  zIndex: 1000,
  gap: Spacings4,

  '@media (max-width: 600px)': {
    flexDirection: 'column',

    button: {
      width: '100%',
    },
  },
});

const ContinueBarStyles = {
  wrapper,
};

export default ContinueBarStyles;
